import React from "react";
import AllStatistiqueBien from "./AllStatistiqueBien";
import { useSelector } from "react-redux";
import { Help } from "../../utils";
// console.log()

export default function FinanceStatistiques({ typePeriodeFilter }) {
  const datasetProprieteVenteMaison = useSelector(
    (state) => state.proprietesVenteMaisonStatistiqueFinance.data
  );
  const datasetProprieteVenteTerrain = useSelector(
    (state) => state.proprietesVenteTerrainStatistiqueFinance.data
  );
  const datasetProprieteLocationMaison = useSelector(
    (state) => state.proprietesLocationMaisonStatistiqueFinance.data
  );

  console.log("datasetProprieteLocationMaison", datasetProprieteLocationMaison);
  console.log("typePeriodeFilter", typePeriodeFilter);
  return (
    <>
      {typePeriodeFilter === "Maison en location" && (
        <CompomentChildrenForStatistique
          dataset={datasetProprieteLocationMaison}
        />
      )}
      {typePeriodeFilter === "Maison en vente" && (
        <CompomentChildrenForStatistique
          dataset={datasetProprieteVenteMaison}
        />
      )}
      {typePeriodeFilter === "Terrain en vente" && (
        <CompomentChildrenForStatistique
          dataset={datasetProprieteVenteTerrain}
        />
      )}
    </>
  );
}

const CompomentChildrenForStatistique = ({ dataset }) => {
  const valueMoneyFormatter = (value) => `${Help.convertInMoney(value)} Fcfa`;
  return (
    <AllStatistiqueBien
      titleStatitisque={"Finances"}
      // titleStatitisqueDormant={"Finances dormants"}
      dataSeries={[
        {
          dataKey: "previsions",
          label: "Prévisions",
          // label: "Portefeuille global",
          valueFormatter: valueMoneyFormatter,
        },
        {
          dataKey: "revenus",
          // label: "revenues",
          label: "Revenu actif",
          valueFormatter: valueMoneyFormatter,
        },
        {
          dataKey: "recouvrement",
          label: "recouvrement",
          valueFormatter: valueMoneyFormatter,
        },
      ]}
      dataset={dataset}
    />
  );
};
